import Decimal from "decimal.js"

export const inchesToFeet = (inches) => {
  return Math.ceil(inches / 12)
}

export const inchesToFeetAndInches = (totalInches) => {
  const inches = totalInches % 12
  const feet = (totalInches - inches) / 12
  return { feet, inches }
}

export const inchesToSquareFeet = (inches) => {
  return Math.ceil(inches / 144)
}

export const feetToInches = (feet) => {
  return feet * 12
}

export const formattedFeet = (feet) => {
  return `${feet}'`
}

export const formatDimension = (totalInches) => {
  if (!totalInches) return ""
  const { feet, inches } = inchesToFeetAndInches(totalInches)
  if (feet === 0) return `${inches}"`
  if (inches === 0) return `${feet}'`
  return `${feet}' ${inches}"`
}

export const formattedDollars = (dollars, precision = 2, currency = "USD") => {
  let prefix = ""

  if (dollars < 0) {
    prefix = "-"
  }

  return (
    prefix +
    new Decimal(dollars)
      .abs()
      .toNumber()
      .toLocaleString("en-US", {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
        style: "currency",
        currency: currency || "USD",
      })
  )
}

export const formatCurrencyFromMinorUnits = ({
  amount,
  currency = "USD",
  precision = 2,
}) => {
  const divisor = 10 ** precision
  return formattedDollars(
    new Decimal(amount).div(divisor).toNumber(),
    precision,
    currency
  )
}
export const formattedDecimalToTax = (taxDecimal) => {
  try {
    return `${new Decimal(taxDecimal).mul(100).toNumber()}%`
  } catch (e) {
    return null
  }
}

export const centsToDollars = (cents) => {
  try {
    return new Decimal(cents).div(100).toFixed(2)
  } catch (e) {
    return null
  }
}

export const percentToDecimal = (percent) => {
  try {
    return new Decimal(percent).div(100).toFixed(2)
  } catch (e) {
    return null
  }
}
